const translations = {
  "en": {
    "Check payment status": "Check payment status",
    "Ed": "Ed",
    "Get Ed Complete": "Get Ed Complete",
    "Not available": "Not available",
    "Restore purchase": "Restore purchase"
  },
  "zh-tw": {
    "Check payment status": "查看付款狀態",
    "Ed": "Ed",
    "Get Ed Complete": "訂閱 Ed Complete",
    "Not available": "無法使用",
    "Restore purchase": "恢復購買"
  }
};

export default translations;
